export default "../images/empty-folder.png?ebe7dfe32eabb3e83042c3dadde67ed4";